import { StateSelectorProps } from '@/components/StateSelector';

export type StateSelectorList = StateSelectorListItem[];

export interface StateSelectorListItem {
  name: string;
  url: string;
}

const stateVariants = {
  BadenWuerttemberg: 'Baden-Württemberg',
  Bayern: 'Bayern',
  Berlin: 'Berlin',
  Brandenburg: 'Brandenburg',
  Bremen: 'Bremen',
  Hamburg: 'Hamburg',
  Hessen: 'Hessen',
  MecklenburgVorpommern: 'Mecklenburg-Vorpommern',
  Niedersachsen: 'Niedersachsen',
  NordrheinWestfalen: 'Nordrhein-Westfalen',
  RheinlandPfalz: 'Rheinland-Pfalz',
  Saarland: 'Saarland',
  Sachsen: 'Sachsen',
  SachsenAnhalt: 'Sachsen-Anhalt',
  SchleswigHolstein: 'Schleswig-Holstein',
  Thueringen: 'Thüringen',
};

export function mapStateSelectorPropsToList(
  props: StateSelectorProps
): StateSelectorList {
  return Object.keys(props).reduce((list: StateSelectorList, key: string) => {
    if (stateVariants[key] && props[key] && props[key] !== '') {
      list.push({
        name: stateVariants[key],
        url: props[key],
      });
    }
    return list;
  }, []);
}
